<div class="modal solid" id="AddAllModal">
  <div (click)="close()" class="closeButton icon-HamburgerAppClose" id="CloseAddAllButton"></div>
  <div class="title">What Would You Like to Add?</div>
  <div class="grid three">
    <div></div>
    @if (canCreateNetworks) {
      <div (click)="open('network')" class="iconButton" id="addNetwork">
        <div class="image icon-networks"></div>
        <div class="label">Add a New<br />Network</div>
      </div>
    }
    <div></div>
  </div>
  <div class="grid two">
    @if (canCreateAppwans) {
      <div (click)="open('appwan')" class="iconButton" id="addAppwan">
        <div class="image icon-appwan"></div>
        <div class="label">
          Add a New<br />{{ featureService.enableNewNavigation ? 'Service Policy' : 'AppWAN' }}
        </div>
      </div>
    }

    @if (canCreateEndpoints) {
      <div
        (click)="open('endpoint')"
        class="iconButton"
        id="addEndpoint"
        >
        <div class="image icon-endpoints"></div>
        <div class="label">Add a New<br />{{ featureService.enableNewNavigation ? 'Identity' : 'Endpoint' }}</div>
      </div>
    }

    @if (canCreateEdgeRouters) {
      <div
        (click)="open('edgeRouter')"
        class="iconButton"
        id="addEdgeRouter"
        >
        <div class="image icon-routers"></div>
        <div class="label">Add a New<br />Edge Router</div>
      </div>
    }

    @if (canCreateEdgeRouterPolicies) {
      <div
        (click)="open('edgeRouterPolicy')"
        class="iconButton"
        id="addEdgeRouterPolicy"
        >
        <div class="image icon-routerpolicy"></div>
        <div class="label">Add a New<br />Edge Router Policy</div>
      </div>
    }

    @if (canCreateServices) {
      <div (click)="open('service')" class="iconButton" id="addService">
        <div class="image icon-addServices"></div>
        <div class="label">Add a New<br />Service</div>
      </div>
    }
  </div>
</div>
